import { Params } from "./types";
let urlParams: Params;

export const getUrlParams = () =>
    new Promise<Params>((resolve, _) => {
        const queryString = window.location.search;

        const params = new URLSearchParams(queryString);
        let paramStr = params.toString().replace('id=', '');

        let id = params.get('id')
        let packType: string | null;
        let penType: string | null;
        let penNum: number | string | null;
        let gyro: boolean;

        if (id != null && id != 'POS' && id != 'Social') {

            penNum = id.replace(/\D/g, '');
            penType = id.replace(/[0-9]/g, '').replace(/[^a-z]/g, '');
            packType = id.replace(/[0-9]/g, '').replace(/[^A-Z]/g, '');
            penType = penType == 'bt' ? 'bullet' : 'brush'
            packType = packType == 'G' ? 'newGlobal' : 'new'

            gyro = penNum == '12' ? true : false; // May need to change at later date when non-new packs are released

        }
        else {
            gyro = true;
            penType = 'brush';
            penNum = '5';
            packType = "newGlobal";
        }
        //Global brush 2 pack does not exsist
        packType = packType == "newGlobal" && packType && penType == 'brush' && penNum == '2' ? 'new' : packType;

        penNum = parseInt(penNum)

        urlParams = {
            paramStr,
            packType,
            penType,
            penNum,
            gyro
        };

        resolve(urlParams)
    })
